import { Check, Plus } from "lucide-react";

export const ADDONS = [
    { id: "pet-hair", name: "Pet Hair Removal", price: "+$35" },
    { id: "headliner-cleaning", name: "Headliner Cleaning", price: "+$55" },
    { id: "engine-bay", name: "Engine Bay Degrease/Detail", price: "+$45" },
    { id: "ceramic-spray", name: "Ceramic Spray Coating", price: "+$75" },
    { id: "clay-bar", name: "Clay Bar/Sealant", price: "+$100" },
    { id: "trim-restoration", name: "Trim & Plastic Restoration", price: "+$30" },
    { id: "odor-bomb", name: "Ozone Odor Treatment", price: "+$50" },
    { id: "car-seat-cleaning", name: "Car Seat Cleaning", price: "+$25" },
];

export default function AddOns({ selected, onToggle }) {
    return (
        <section
            id="addons"
            data-testid="addons-section"
            className="relative py-24 md:py-32 px-6 md:px-12 bg-[#0A0A0A] border-t border-white/5"
        >
            <div className="max-w-7xl mx-auto">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
                    <div className="max-w-2xl">
                        <div className="font-heading text-xs uppercase tracking-[0.32em] text-[#9D4CDD] font-bold mb-4">
                            / Optional Add-Ons
                        </div>
                        <h2
                            data-testid="addons-heading"
                            className="font-heading text-4xl md:text-5xl font-black uppercase tracking-tighter text-white"
                        >
                            Stack. Customize.{" "}
                            <span className="text-[#9D4CDD]">Perfect it.</span>
                        </h2>
                        <p className="mt-5 text-white/60 leading-relaxed">
                            Tap any add-on to include it with your booking. We&apos;ll
                            confirm pricing when we reach out.
                        </p>
                    </div>
                    <div className="text-xs font-heading uppercase tracking-[0.24em] text-white/40">
                        {selected.length} selected
                    </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                    {ADDONS.map((a) => {
                        const active = selected.includes(a.name);
                        return (
                            <button
                                key={a.id}
                                type="button"
                                data-testid={`addon-toggle-${a.id}`}
                                aria-pressed={active}
                                onClick={() => onToggle(a.name)}
                                className={`group relative text-left p-5 border transition-all ${
                                    active
                                        ? "border-[#9D4CDD] bg-[#9D4CDD]/10 shadow-[0_0_24px_-8px_rgba(157,76,221,0.45)]"
                                        : "border-white/8 bg-[#121212] hover:border-[#9D4CDD]/40"
                                }`}
                            >
                                <div className="flex items-start justify-between mb-4">
                                    <div
                                        className={`w-8 h-8 flex items-center justify-center border transition-colors ${
                                            active
                                                ? "border-[#9D4CDD] bg-[#9D4CDD] text-white"
                                                : "border-white/15 text-white/40"
                                        }`}
                                    >
                                        {active ? (
                                            <Check size={14} />
                                        ) : (
                                            <Plus size={14} />
                                        )}
                                    </div>
                                    <span
                                        className={`font-heading text-xs font-bold tracking-[0.18em] uppercase ${
                                            active
                                                ? "text-[#9D4CDD]"
                                                : "text-white/50"
                                        }`}
                                    >
                                        {a.price}
                                    </span>
                                </div>
                                <div className="font-heading text-base font-semibold text-white leading-tight">
                                    {a.name}
                                </div>
                            </button>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
